var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncementFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9931 16.1175C12.0378 16.1176 12.2108 16.1194 12.4706 16.1646L12.4353 16.741C12.4235 17.0469 12.1647 17.294 11.8588 17.294C11.1765 17.294 10.7059 17.494 10.3882 17.894C9.67058 18.8116 9.91765 20.6352 10.0706 21.2705C10.1176 21.4469 10.0706 21.6352 9.96471 21.7763C9.84706 21.9175 9.68235 21.9999 9.50589 21.9999H7.29411C6.96471 21.9999 6.70589 21.741 6.70589 21.4116V16.1175H11.9931ZM18.5329 2.3254C18.6541 2.0807 18.9247 1.95482 19.1941 2.01482C19.46 2.07835 19.6471 2.31482 19.6471 2.58776V7.94187C20.9882 8.21482 22 9.40305 22 10.823C22 12.243 20.9882 13.4325 19.6471 13.7054V19.0583C19.6471 19.3313 19.46 19.5689 19.1941 19.6313C19.1497 19.6415 19.1044 19.6467 19.0588 19.6466C18.8388 19.6466 18.6341 19.5242 18.5329 19.3219C16.3671 14.9913 12.0435 14.9407 12 14.9407H6.11765C4.49529 14.9407 3.17647 13.6219 3.17647 11.9995V11.4113H2.58824C2.26353 11.4113 2 11.1489 2 10.8231C2 10.4984 2.26353 10.2348 2.58823 10.2348H3.17647V9.64659C3.17647 8.0254 4.49529 6.7054 6.11765 6.7054H11.9988C12.1753 6.70423 16.3788 6.63247 18.5329 2.3254Z",
    fill: "#0098DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementFilled);
export default __webpack_public_path__ + "static/media/announcement-filled.b5c961f6138ee3ab60f29f9975d29de1.svg";
export { ForwardRef as ReactComponent };